<script setup lang="ts">
import { onMounted } from 'vue';

import JobEditContentSection from '@/components/sections/JobEditContentSection.vue';
import { useJobEditStore } from '@/stores/useJobEditStore';

export interface Props {
  jobId: number;
  jobDate: string;
}
const props = withDefaults(defineProps<Props>(), {});

const jobEditStore = useJobEditStore();

onMounted(async () => {
  jobEditStore.init(props.jobId, props.jobDate);
  await jobEditStore.loadJob();
});
</script>

<template>
  <div :class="$style.jobEditPage">
    <JobEditContentSection />
  </div>
</template>

<style module lang="scss">
.jobEditPage {
  max-width: 1920px;
  margin: 0 auto;
  // Own scroll container starting below the fixed app bar, so the sticky
  // section header sticks under it instead of scrolling behind it.
  height: calc(100vh - var(--v-layout-top, 0px));
  overflow-y: auto;
}
</style>
